import { useState } from 'react';
import { useCoverLetterEditor } from '../../context/CoverLetterContext';
import { RiMagicLine, RiDownloadLine, RiLoader4Line } from 'react-icons/ri';
import { useReactToPrint } from 'react-to-print';

const TABS = [
    { id: 'ai', label: 'AI Assistant', icon: RiMagicLine },
    { id: 'export', label: 'Export', icon: RiDownloadLine },
];

function AIImprovementTab() {
    const { improveWithAI, isGenerating } = useCoverLetterEditor();
    const [instruction, setInstruction] = useState('');

    const handleImprove = async () => {
        if (!instruction.trim()) return;
        await improveWithAI(instruction);
        setInstruction('');
    };

    return (
        <div className="p-4 flex flex-col gap-4">
            <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider">AI Improvement</h3>
            <div className="flex flex-col gap-2">
                <textarea
                    value={instruction}
                    onChange={(e) => setInstruction(e.target.value)}
                    placeholder="e.g., Make the opening paragraph more enthusiastic..."
                    className="w-full h-32 bg-black/50 border border-white/10 rounded-lg p-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-brand-500 transition-colors resize-none"
                />
                <button
                    onClick={handleImprove}
                    disabled={isGenerating || !instruction.trim()}
                    className="flex items-center justify-center gap-2 bg-brand-500 hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed text-white py-2 rounded-lg font-medium transition-all"
                >
                    {isGenerating ? (
                        <>
                            <RiLoader4Line className="animate-spin" />
                            Improving...
                        </>
                    ) : (
                        <>
                            <RiMagicLine />
                            Improve Content
                        </>
                    )}
                </button>
            </div>
            <div className="text-xs text-gray-500 mt-2">
                <p>Pro Tip: precise instructions yield better results.</p>
            </div>
        </div>
    );
}

function ExportTab() {
    const { canvasRef } = useCoverLetterEditor();

    const handleDownload = useReactToPrint({
        contentRef: canvasRef,
        documentTitle: 'Cover_Letter',
        onAfterPrint: () => console.log('Print success'),
    });

    return (
        <div className="p-4 flex flex-col gap-4">
            <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider">Download</h3>
            <button
                onClick={() => handleDownload()}
                className="flex items-center justify-center gap-2 w-full py-3 bg-white text-black hover:bg-gray-100 rounded-lg font-medium transition-all"
            >
                <RiDownloadLine size={18} />
                Download PDF
            </button>
        </div>
    );
}

export default function CoverLetterSidePanel() {
    const [activeTab, setActiveTab] = useState('ai');

    return (
        <div className="h-full flex flex-col text-white">
            {/* Tabs */}
            <div className="flex border-b border-white/5">
                {TABS.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex-1 flex items-center justify-center gap-2 py-4 text-sm font-medium transition-colors relative ${activeTab === tab.id ? 'text-white' : 'text-gray-500 hover:text-gray-400'
                            }`}
                    >
                        <tab.icon size={16} />
                        {tab.label}
                        {activeTab === tab.id && (
                            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-brand-500" />
                        )}
                    </button>
                ))}
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto">
                {activeTab === 'ai' && <AIImprovementTab />}
                {activeTab === 'export' && <ExportTab />}
            </div>
        </div>
    );
}
